module.exports = __webpack_public_path__ + "img/ferdi-kaza-sigortasi.f510d800.png";